import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  promoCodes: [],
  listPagination: {},
  promoCode: {},
  fetchingPromoCodes: FETCH_STATE.UNSENT,
  fetchingPromoCode: FETCH_STATE.UNSENT,
  createPromoCode: FETCH_STATE.UNSENT,
  updatePromoCode: FETCH_STATE.UNSENT,
  deletePromoCode: FETCH_STATE.UNSENT,
};

const promoCodesReducer = createReducer(initialState)({
  [types.FETCH_PROMO_CODES_REQUEST]: (state) => {
    return {
      ...state,
      promoCodes: [],
      fetchingPromoCodes: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_PROMO_CODES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      promoCodes: payload.data,
      fetchingPromoCodes: FETCH_STATE.DONE,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_PROMO_CODES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingPromoCodes: FETCH_STATE.ERROR,
    };
  },
  // Get promo code by id
  [types.FETCH_PROMO_CODE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      promoCode: {},
      fetchingPromoCode: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_PROMO_CODE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      promoCode: payload.data,
      fetchingPromoCode: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_PROMO_CODE_BY_ID_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingPromoCode: FETCH_STATE.ERROR,
    };
  },
  // Create Promo Code
  [types.CREATE_PROMO_CODE_REQUEST]: (state) => {
    return {
      ...state,
      createPromoCode: FETCH_STATE.LOADING,
    };
  },
  [types.CREATE_PROMO_CODE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      promoCode: payload,
      createPromoCode: FETCH_STATE.DONE,
    };
  },
  [types.CREATE_PROMO_CODE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      createPromoCode: FETCH_STATE.ERROR,
    };
  },
  [types.RESET_PROMO_CODE]: (state) => {
    return {
      ...initialState,
    };
  },
  [types.DELETE_PROMO_CODE_REQUEST]: (state) => {
    return {
      ...state,
      deletePromoCode: FETCH_STATE.LOADING,
    };
  },
  [types.DELETE_PROMO_CODE_SUCCESS]: (state) => {
    return {
      ...state,
      deletePromoCode: FETCH_STATE.DONE,
    };
  },
  [types.DELETE_PROMO_CODE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      deletePromoCode: FETCH_STATE.ERROR,
    };
  },
  [types.UPDATE_PROMO_CODE_REQUEST]: (state) => {
    return {
      ...state,
      updatePromoCode: FETCH_STATE.LOADING,
    };
  },
  [types.UPDATE_PROMO_CODE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      promoCode: payload,
      updatePromoCode: FETCH_STATE.DONE,
    };
  },
  [types.UPDATE_PROMO_CODE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      updatePromoCode: FETCH_STATE.ERROR,
    };
  },
  [types.UPDATE_PROMO_CODE_RESET]: (state) => {
    return {
      ...state,
      updatePromoCode: FETCH_STATE.UNSENT,
    };
  },
});

export default promoCodesReducer;
